var m = require('mithril');
var Velocity = require('velocity-animate');
 

exports.fliesIn = function(element, isInitialized, context) {
    if (!isInitialized) {
        element.style.marginRight = "100em"
        Velocity(element, {marginRight: "inherits"})
    }
}

exports.flyOut = function(callback, targetId) {
    return function(e) {
        var target = document.getElementById(targetId)
        //don't redraw yet
        e.redraw = false
        target.classList.add("flying-out")
        Velocity(target, {marginLeft: "100em"}, {
            duration: 300,
            complete: function() {
                //now that the animation finished, redraw
                callback()
                m.redraw()
            }
        })
    }
}

exports.fadeOut = function(callback, target) {
    return function(e) {
        //don't redraw yet
        m.redraw.strategy("none")

        Velocity(target, {opacity: 0}, {
            complete: function() {
                //now that the animation finished, redraw
                m.startComputation()
                callback()
                m.endComputation()
            }
        })
    }
}

exports.fadesIn = function(vnode) {
    var element = vnode.dom
    element.style.opacity = 0
    Velocity(element, {opacity: 1})
}

exports.pulses = function(element, isInitialized, context) {
    Velocity(element, {opacity: 0})
    Velocity(element, {opacity: 1})
}

exports.typer = function (vnode) {
  var state = this;
  var el = vnode.dom;
  var text = el.getAttribute('typewriterString') || '';

  // If the text to render changed, start animation and lock width
  if (state.text !== text) {
    lockWidth(el, text);
    typeWriter(text, 0);
    state.text = text;
  } else {
    // No animation needed; ensure final text is shown
    el.textContent = text;
  }

  function lockWidth(el, fullText) {
    try {
      // Create a hidden clone next to the element to measure final width
      var clone = el.cloneNode(true);
      clone.style.visibility = 'hidden';
      clone.style.position = 'absolute';
      clone.style.whiteSpace = 'pre';
      clone.style.width = 'auto';
      clone.textContent = fullText;
      // Append to the same parent to inherit styles
      if (el.parentNode) el.parentNode.appendChild(clone);
      var width = clone.getBoundingClientRect().width;
      if (clone.parentNode) clone.parentNode.removeChild(clone);

      // Lock width during animation to avoid layout jank
      el.style.display = 'inline-block';
      el.style.width = width + 'px';
    } catch (e) {
      // Fallback: approximate using character count
      el.style.display = 'inline-block';
      el.style.width = fullText.length + 'ch';
    }
  }

  function typeWriter(text, n) {
    if (n < text.length) {
      el.textContent = text.substring(0, n + 1);
      setTimeout(function () {
        typeWriter(text, n + 1);
      }, 40);
    } else {
      // Animation complete; keep width locked until next change
      el.textContent = text;
    }
  }
}
